import { blue } from '@ant-design/colors';
import { clearFix, textEllipsis } from '../../style';
import { unit } from '@ant-design/cssinjs';
const genPictureStyle = token => {
  const {
    componentCls,
    iconCls,
    uploadThumbnailSize,
    uploadProgressOffset,
    calc
  } = token;
  const listCls = "".concat(componentCls, "-list");
  const itemCls = "".concat(listCls, "-item");
  return {
    ["".concat(componentCls, "-wrapper")]: {
      // ${listCls} 增加优先级
      ["\n        ".concat(listCls).concat(listCls, "-picture,\n        ").concat(listCls).concat(listCls, "-picture-card,\n        ").concat(listCls).concat(listCls, "-picture-circle\n      ")]: {
        [itemCls]: {
          position: 'relative',
          height: calc(uploadThumbnailSize).add(calc(token.lineWidth).mul(2)).add(calc(token.paddingXS).mul(2)).equal(),
          padding: token.paddingXS,
          border: "".concat(unit(token.lineWidth), " ").concat(token.lineType, " ").concat(token.colorBorder),
          borderRadius: token.borderRadiusLG,
          '&:hover': {
            background: 'transparent'
          },
          ["".concat(itemCls, "-thumbnail")]: Object.assign(Object.assign({}, textEllipsis), {
            width: uploadThumbnailSize,
            height: uploadThumbnailSize,
            lineHeight: unit(calc(uploadThumbnailSize).add(token.paddingSM).equal()),
            textAlign: 'center',
            flex: 'none',
            [iconCls]: {
              fontSize: token.fontSizeHeading2,
              color: token.colorPrimary
            },
            img: {
              display: 'block',
              width: '100%',
              height: '100%',
              overflow: 'hidden'
            }
          }),
          ["".concat(itemCls, "-progress")]: {
            bottom: uploadProgressOffset,
            width: "calc(100% - ".concat(unit(calc(token.paddingSM).mul(2).equal()), ")"),
            marginTop: 0,
            paddingInlineStart: calc(uploadThumbnailSize).add(token.paddingXS).equal()
          }
        },
        ["".concat(itemCls, "-error")]: {
          borderColor: token.colorError,
          // Adjust the color of the error icon : https://github.com/ant-design/ant-design/pull/24160
          ["".concat(itemCls, "-thumbnail ").concat(iconCls)]: {
            ["svg path[fill='".concat(blue[0], "']")]: {
              fill: token.colorErrorBg
            },
            ["svg path[fill='".concat(blue.primary, "']")]: {
              fill: token.colorError
            }
          }
        },
        ["".concat(itemCls, "-uploading")]: {
          borderStyle: 'dashed',
          ["".concat(itemCls, "-name")]: {
            marginBottom: uploadProgressOffset
          }
        }
      },
      ["".concat(listCls).concat(listCls, "-picture-circle ").concat(itemCls)]: {
        ["&, &::before, ".concat(itemCls, "-thumbnail")]: {
          borderRadius: '50%'
        }
      }
    }
  };
};
const genPictureCardStyle = token => {
  const {
    componentCls,
    iconCls,
    fontSizeLG,
    colorTextLightSolid,
    calc
  } = token;
  const listCls = "".concat(componentCls, "-list");
  const itemCls = "".concat(listCls, "-item");
  const uploadPictureCardSize = token.uploadPicCardSize;
  return {
    ["\n      ".concat(componentCls, "-wrapper").concat(componentCls, "-picture-card-wrapper,\n      ").concat(componentCls, "-wrapper").concat(componentCls, "-picture-circle-wrapper\n    ")]: Object.assign(Object.assign({}, clearFix()), {
      display: 'inline-block',
      width: '100%',
      ["".concat(componentCls).concat(componentCls, "-select")]: {
        width: uploadPictureCardSize,
        height: uploadPictureCardSize,
        marginInlineEnd: token.marginXS,
        marginBottom: token.marginXS,
        textAlign: 'center',
        verticalAlign: 'top',
        backgroundColor: token.colorFillAlter,
        border: "".concat(unit(token.lineWidth), " dashed ").concat(token.colorBorder),
        borderRadius: token.borderRadiusLG,
        cursor: 'pointer',
        transition: "border-color ".concat(token.motionDurationSlow),
        ["> ".concat(componentCls)]: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          textAlign: 'center'
        },
        ["&:not(".concat(componentCls, "-disabled):hover")]: {
          borderColor: token.colorPrimary
        }
      },
      // list
      ["".concat(listCls).concat(listCls, "-picture-card, ").concat(listCls).concat(listCls, "-picture-circle")]: {
        ["".concat(listCls, "-item-container")]: {
          display: 'inline-block',
          width: uploadPictureCardSize,
          height: uploadPictureCardSize,
          marginBlock: "0 ".concat(unit(token.marginXS)),
          marginInline: "0 ".concat(unit(token.marginXS)),
          verticalAlign: 'top'
        },
        '&::after': {
          display: 'none'
        },
        [itemCls]: {
          height: '100%',
          margin: 0,
          '&::before': {
            position: 'absolute',
            zIndex: 1,
            width: "calc(100% - ".concat(unit(calc(token.paddingXS).mul(2).equal()), ")"),
            height: "calc(100% - ".concat(unit(calc(token.paddingXS).mul(2).equal()), ")"),
            backgroundColor: token.colorBgMask,
            opacity: 0,
            transition: "all ".concat(token.motionDurationSlow),
            content: '" "'
          }
        },
        ["".concat(itemCls, ":hover")]: {
          ["&::before, ".concat(itemCls, "-actions")]: {
            opacity: 1
          }
        },
        ["".concat(itemCls, "-actions")]: {
          position: 'absolute',
          insetInlineStart: 0,
          zIndex: 10,
          width: '100%',
          whiteSpace: 'nowrap',
          textAlign: 'center',
          opacity: 0,
          transition: "all ".concat(token.motionDurationSlow),
          ["\n            ".concat(iconCls, "-eye,\n            ").concat(iconCls, "-download,\n            ").concat(iconCls, "-delete\n          ")]: {
            zIndex: 10,
            width: fontSizeLG,
            margin: "0 ".concat(unit(token.marginXXS)),
            fontSize: fontSizeLG,
            cursor: 'pointer',
            transition: "all ".concat(token.motionDurationSlow),
            color: colorTextLightSolid,
            '&:hover': {
              color: colorTextLightSolid
            },
            svg: {
              verticalAlign: 'baseline'
            }
          }
        },
        ["".concat(itemCls, "-thumbnail, ").concat(itemCls, "-thumbnail img")]: {
          position: 'static',
          display: 'block',
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        },
        ["".concat(itemCls, "-name")]: {
          display: 'none',
          textAlign: 'center'
        },
        ["".concat(itemCls, "-file + ").concat(itemCls, "-name")]: {
          position: 'absolute',
          bottom: token.margin,
          display: 'block',
          width: "calc(100% - ".concat(unit(calc(token.paddingXS).mul(2).equal()), ")")
        },
        ["".concat(itemCls, "-uploading")]: {
          ["&".concat(itemCls)]: {
            backgroundColor: token.colorFillAlter
          },
          ["&::before, ".concat(iconCls, "-eye, ").concat(iconCls, "-download, ").concat(iconCls, "-delete")]: {
            display: 'none'
          }
        },
        ["".concat(itemCls, "-progress")]: {
          bottom: token.marginXL,
          width: "calc(100% - ".concat(unit(calc(token.paddingXS).mul(2).equal()), ")"),
          paddingInlineStart: 0
        }
      }
    }),
    ["".concat(componentCls, "-wrapper").concat(componentCls, "-picture-circle-wrapper")]: {
      ["".concat(componentCls).concat(componentCls, "-select")]: {
        borderRadius: '50%'
      }
    }
  };
};
export { genPictureStyle, genPictureCardStyle };